import { render } from "./PurchaseOrderIcon.vue?vue&type=template&id=f4f5a514"
import script from "./PurchaseOrderIcon.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderIcon.vue?vue&type=script&lang=js"

import exportComponent from "/container/application/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__